// extracted by mini-css-extract-plugin
export default {"sub-title":"OrderInfo_sub-title__AFjfK"};